import { SlideHeader, StepList, DeepDive, SiteLink } from "../shared";
import { SolutionLoop } from "@/components/SolutionLoop";

export function Slide02Works() {
  const STEPS = [
    { title: "The band senses", desc: "Sensor under the strap: skin temperature, sweat and heart rate." },
    { title: "The AI learns", desc: "Your routine, your formulation and local UV." },
    { title: "The intelligence prompts", desc: "It tells you when it's time to apply." },
    { title: "You act and apply", desc: "Already on your wrist.", badge: "Available Today" },
    { title: "It keeps learning", desc: "Smarter with every prompt and your feedback." },
  ];
  return (
    <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-5xl" data-testid="pitch-slide-works">
      <div>
        <SlideHeader n="02" label="How It Works" />
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light tracking-tighter leading-[1.08] text-white">
          Other wearables tell you it's time.{" "}
          <span className="text-accent">WearSpray puts the formulation in your hand.</span>
        </h2>
        <StepList testid="pitch-works-steps" steps={STEPS} />
      </div>
      <div className="flex flex-col items-center">
        <SolutionLoop />
        <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-zinc-500 mt-2 text-center">
          Step 4 is available today. Steps 1, 2, 3 and 5 are in development.
        </p>
        <div className="mt-2">
          <DeepDive testid="works" title="The Sensor Roadmap">
            <p className="font-body text-zinc-300 text-sm leading-relaxed">
              WearSpray's dispenser works today, on its own. The sensing, AI and prompting layers
              are the near-term roadmap, building on an already-issued patent claim that pairs
              body sensing with the dispenser.
            </p>
            <SiteLink href="https://wearspray.com/technology">See the technology on wearspray.com</SiteLink>
          </DeepDive>
        </div>
      </div>
    </div>
  );
}
